import React from 'react';
import VoiceAssistant from './components/VoiceAssistant';

function App() {
  return (
    <div className="App">
      <VoiceAssistant />
    </div>
  );
}

export default App;

